<template>
    <el-menu :default-active="$route.path" class="el-menu-vertical-demo" v-if="role === 'ADMIN'">
        <el-menu-item index="/userReview" @click="goUserList">
            <el-icon><User /></el-icon>
            <template #title>用户审核</template>
        </el-menu-item>
        <el-menu-item index="/userManage" @click="goUserManage">
            <el-icon>
                <document />
            </el-icon>
            <template #title>用户管理</template>
        </el-menu-item>
        <el-menu-item index="/taskListAll" @click="goTaskListAll">
            <el-icon>
                <document />
            </el-icon>
            <template #title>任务管理</template>
        </el-menu-item>
        <el-menu-item index="/ticketIssuance" @click="goTicketIssuance">
            <el-icon>
                <document />
            </el-icon>
            <template #title>票券发放</template>
        </el-menu-item>
        <el-menu-item index="/invoicingApplication" @click="goInvoicingApplication">
            <el-icon>
                <document />
            </el-icon>
            <template #title>开票申请</template>
        </el-menu-item>
    </el-menu>
    <el-menu :default-active="$route.path" class="el-menu-vertical-demo" v-else>
        <el-menu-item index="/frontPage" @click="goFrontPage" :disabled="disabled">
            <i class="iconfont icon-shouye"></i>
            <template #title>首页</template>
        </el-menu-item>
        <el-menu-item index="/addTask" @click="goAdd" :disabled="disabled">
            <i class="iconfont icon-xinjian"></i>
            <template #title>新建任务</template>
        </el-menu-item>
        <el-menu-item index="/taskList" @click="goList" :disabled="disabled">
            <i class="iconfont icon-liebiao"></i>
            <template #title>任务列表</template>
        </el-menu-item>
        <el-menu-item index="/pay" @click="goPay" :disabled="disabled">
            <i class="iconfont icon-vip"></i>
            <template #title>服务报价</template>
        </el-menu-item>
        <el-menu-item index="/userHelp" @click="goUserHelp" :disabled="disabled">
            <i class="iconfont icon-info"></i>
            <template #title>用户指引</template>
        </el-menu-item>
        <el-menu-item index="/problemHelp" @click="goProblem" :disabled="disabled">
            <i class="iconfont icon-weiqianyue"></i>
            <template #title>联系我们</template>
        </el-menu-item>
    </el-menu>
</template>
<script>
export default {
    data() {
        return {
            role: '',
            disabled: true,
        }
    },
    mounted() {
        if (localStorage.getItem('role')) {
            this.role = localStorage.getItem('role')
        }
        if (localStorage.getItem('userId')){
            this.disabled = false
        }else {
            this.disabled = true
        }
    },
    methods: {
        goFrontPage() {
            this.$router.push('/frontPage')
        },
        goAdd() {
            this.$router.push('/addTask')
        },
        goPay() {
            this.$router.push('/pay')
        },
        goList() {
            this.$router.push('/taskList')
        },
        goUserHelp() {
            this.$router.push('/userHelp')
        },
        goUserList() {
            this.$router.push('/userReview')
        },
        goUserManage(){
            this.$router.push('/userManage')
        },
        goTicketIssuance(){
            this.$router.push('/ticketIssuance')
        },
        goInvoicingApplication(){
            this.$router.push('/invoicingApplication')
        },
        goTaskListAll() {
            this.$router.push('/taskListAll')
        },
        goProblem() {
            this.$router.push('/problemHelp')
        },
        goApplication() {
            this.$router.push('/billApplication')
        },
    }
}

</script>
<style scoped>
.el-menu-vertical-demo {
    height: 100%;
    background-color: #F5F5F5!important;
    border: none!important;
    height: 100%;
}
.el-menu-item{
    font-size: 0.20rem !important;
}
.iconfont{
    font-size: 0.20rem !important;
}
.iconfont{
    width: 0.24rem;
    margin-right: 0.05rem;
    text-align: center;
}
</style>